module.exports = __webpack_public_path__ + "img/py.9b51074b.svg";